import React, { useState } from 'react';
import { ActionBarStyled, SelectStyled } from '../../../components/PageAction/styles';
import { FlexboxStyled } from '../../../styles/IndexStyles';
import { InputWrapper } from '../../../styles/EditDeleteStyles';
import InputText from '../../../components/InputText';
import { TextArea } from '../../../components/InputTextArea';
import { LabelStyled } from '../../../components/InputSelect/styles';
import { Sending } from './Shared/Sending';

type BulkReminderProps = {
  onChange: (data: any) => void;
  error: any;
  loading: boolean;
};

export function BulkReminder({ onChange, error, loading }: BulkReminderProps): JSX.Element {
  const [project, setProject] = useState<string>('results_update');
  const [subject, setSubject] = useState<string>('');
  const subjectFormKey = 'bulk_reminder_subject';
  const [body, setBody] = useState<string>('');
  const bodyFormKey = 'bulk_reminder_body';
  const [ctaButtonText, setCtaButtonText] = useState<string>('');
  const ctaButtonTextFormKey = 'cta_button_text';

  React.useEffect(() => {
    onChange({
      project,
      subject,
      body,
      ctaButtonText,
    });
  }, [project, subject, body, ctaButtonText, onChange]);

  if (loading) return <Sending />;

  return (
    <>
      <InputWrapper>
        <ActionBarStyled>
          <FlexboxStyled style={{ marginBottom: 0 }}>
            <LabelStyled htmlFor="action" style={{ color: 'black' }}>
              Choose projects
            </LabelStyled>
            <SelectStyled
              onChange={({ currentTarget }: React.ChangeEvent<HTMLSelectElement>) => {
                setProject(currentTarget?.value);
              }}
              value={project}
            >
              {[
                {
                  value: 'results_update',
                  label: 'Completed projects need results updated',
                },
                {
                  value: 'reb_update', // core_projects.reb_expiry
                  label: 'Projects need REB certificate updated',
                },
              ].map(({ label, value }, i) => (
                <option value={value} key={i}>
                  {label}
                </option>
              ))}
            </SelectStyled>
          </FlexboxStyled>
        </ActionBarStyled>
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={subjectFormKey}
          keyName={subjectFormKey}
          label="Subject"
          error={error?.subject}
          // WIP: Whatever is added to this value, the project details should be added into the template
          placeholder="Please share your study result for {{project_ID}} - {{project_title}}"
          inputValue={subject}
          handleHandle={setSubject}
          padding={false}
          theme="form"
        />
      </InputWrapper>
      <InputWrapper>
        <TextArea
          id={bodyFormKey}
          keyName={bodyFormKey}
          label="Body Text"
          error={error?.body}
          placeholder="Just a friendly reminder to update your research project at your earliest convenience"
          textValue={body}
          handleHandle={setBody}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id={ctaButtonTextFormKey}
          keyName={ctaButtonTextFormKey}
          label={
            <div style={{ lineHeight: 1.4, fontSize: '13px' }}>
              <div>Call to Action Button:</div>
              <div style={{ lineHeight: 1.4, fontSize: '12px' }}>text</div>
            </div>
          }
          error={error?.ctaButtonText}
          placeholder="Enter button text (will link to project or study page)"
          inputValue={ctaButtonText}
          handleHandle={setCtaButtonText}
          padding={false}
          theme="form"
        />
      </InputWrapper>
    </>
  );
}
